import { z } from 'zod';

import { InstanceIdType } from '#core/schema/defs.ts';

export const CogniteTimeSeriesModel = z.object({
  ...InstanceIdType.shape,

  name: z.string().optional(),
  description: z.string().optional(),
  tags: z.string().array().optional(),
  aliases: z.string().array().optional(),
  sourceId: z.string().optional(),
  sourceContext: z.string().optional(),
  isStep: z.boolean().optional(),
  type: z.string().optional(),
  sourceUnit: z.string().optional(),
  assets: InstanceIdType.array().optional(),
  // TODO: CogniteUnit
  // TODO: CogniteAsset
  // TODO: CogniteEquipment
  // TODO: CogniteActivity
});

/** @public */
export type CogniteTimeSeriesModelInput = z.input<typeof CogniteTimeSeriesModel>;
/** @public */
export type CogniteTimeSeriesModelOutput = z.output<typeof CogniteTimeSeriesModel>;
